import Home from '@/app/screens/Home'
import NotFound from '@/app/screens/NotFound'
import Construction from '@/app/screens/Construction'
import About from '@/app/screens/About'
import Driver from '@/app/screens/Driver'
import Operator from '@/app/screens/Operator'
import Reserve from '@/app/screens/Reserve'
import Services from '@/app/screens/Services'
import App from '@/app/screens/App'
import Posts from '@/app/screens/Posts'
import Post from '@/app/screens/Post'
import Contact from '@/app/screens/Contact'
import Complaints from '@/app/screens/Complaints'
import Terms from '@/app/screens/Terms'
import Reports from '@/app/screens/Reports'
import Report from '@/app/screens/Report'

const routes = [
  Home,
  About,
  Terms,
  Construction,
  Driver,
  Operator,
  Reserve,
  Services,
  App,
  Posts,
  Post,
  Contact,
  Complaints,
  Reports,
  Report,
  NotFound,
  {
    path: '*',
    redirect: { name: 'NotFound' }
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/app/config/routes.js